// The dashboard's languages, the Studio's five (nuxt.config.ts, i18n): the code the app uses, the tag the API keeps
// on the person (`users.locale`, api migration 20261026130000) and the name each language gives itself.
// No Nuxt dependency: tested with Node alone.
export const LANGUAGES = [
  { code: "fr", tag: "fr-FR", name: "Français" },
  { code: "en", tag: "en-US", name: "English" },
  { code: "de", tag: "de-DE", name: "Deutsch" },
  { code: "it", tag: "it-IT", name: "Italiano" },
  { code: "es", tag: "es-ES", name: "Español" }
];

/** The app's code of a tag the API keeps ("de-DE" → "de"), or null for none or one the dashboard does not speak. */
export const codeOfTag = (tag) => LANGUAGES.find((language) => language.tag === tag)?.code ?? null;

/** The tag the API keeps for an app's code ("de" → "de-DE"), or null. */
export const tagOfCode = (code) => LANGUAGES.find((language) => language.code === code)?.tag ?? null;
